import { render, staticRenderFns } from "./BuildingFieldEditModal.vue?vue&type=template&id=4dbffbb0&scoped=true&"
import script from "./BuildingFieldEditModal.vue?vue&type=script&lang=js&"
export * from "./BuildingFieldEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbffbb0",
  null
  
)

export default component.exports